// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__14-uU","buttons":"SendReceipts_buttons__11MoC","email":"SendReceipts_email__2d67q","bookApptTitle":"SendReceipts_bookApptTitle__3SE8L"};